export default __webpack_public_path__ + "static/media/storefront.c2e77e9d.svg";